import React from 'react';
import Lottie from 'lottie-react-web'
import logo from '../assets/logo.svg'
import ios from '../assets/ios.svg'
import android from '../assets/android.svg'
import animation from '../assets/animation.json';
import { Link } from 'react-router-dom';

function Home() {

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        {/* <div>
          <Lottie
            options={{
              animationData: animation
            }}
          />
        </div> */}
        
        <div className="store-links">
          {/* <a
            className="link"
            href="https://www.apple.com/ios/app-store/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={ios} className="App-logo" alt="logo" />
          </a> */}
          <a
            className="link"
            href="https://play.google.com/store/apps"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={android} className="App-logo" alt="logo" />
          </a>
        </div>

        <div className="links">
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms and Conditions</Link>
          {/* <Link to="/content">Content Policy</Link> */}
          <a href = "mailto: swapheadd@gmail.com">Contact Us</a>
        </div>
      </header>
    </div>
  );
}

export default Home;